module.exports = __webpack_public_path__ + "static/media/bolt-slash.2e170841.svg";